module.exports = __webpack_public_path__ + "img/migration.5f777bec.png";